import { useLinkParametersFormContext } from '@gov-nx/module/service';
import { Button, ButtonGroupLayout, Icon } from '@gov-nx/ui/web';

export const CmsLinkParametersForm = () => {
	const { link, action, method, parametersInputsKeyValues, onSubmit } =
		useLinkParametersFormContext();

	return (
		<form
			target="_blank"
			action={action}
			method={method}
			onSubmit={onSubmit}>
			{parametersInputsKeyValues.map((param) => (
				<input
					key={param.name}
					hidden={true}
					readOnly={true}
					name={param.name}
					value={param.value}
				/>
			))}
			<ButtonGroupLayout>
				<Button
					type={link.properties.type}
					color={link.properties.color}
					aria-label={link.label}
					nativeType="submit"
					expandedMobile
					iconEnd={
						<Icon
							type="components"
							name="box-arrow-up-right"
						/>
					}>
					{link.label}
				</Button>
			</ButtonGroupLayout>
		</form>
	);
};
